
import { Component, Vue } from 'nuxt-property-decorator'

@Component({ name: 'MessageMiddleLight' })
export default class MessageMiddleLight extends Vue {}
